import { Injectable } from '@angular/core';
import { IReminderContainer, Reminder } from '../models/Reminder';
import { User } from '../models/User';
import { BackendService } from './backend.service';
import { UserService } from './user.service';

@Injectable()
export class ReminderService {
  /** Array containing all user created Programs */
  private allMyReminders: IReminderContainer = { defaultReminder: null, reminders: [] };

  /** Store the current user */
  private user: User = null;

  constructor(private backendService: BackendService, private userService: UserService) {
    this.userService.currentUser.subscribe((user) => {
      if (!user) {
        return;
      }
      this.user = user;
    });
  }

  getMyReminders(): Promise<{ defaultReminder: Reminder; reminders: Reminder[] }> {
    // load from server
    return this.backendService.get('reminder').then((data) => {
      this.allMyReminders = data as IReminderContainer;
      this.allMyReminders.reminders.sort((a, b) => {
        return b.time.hours === a.time.hours ? a.time.minutes - b.time.minutes : a.time.hours - b.time.hours;
      });
      return this.allMyReminders;
    });
  }

  saveNewReminder(reminder: Reminder): Promise<any> {
    return this.backendService.post(`reminder`, reminder).then(() => this.getMyReminders());
  }

  updateMyReminder(reminder: Reminder): Promise<any> {
    return this.backendService.put(`reminder/${reminder._id}/`, reminder).then(() => this.getMyReminders());
  }

  deleteMyReminder(reminder: Reminder): Promise<any> {
    return this.backendService
      .delete_(`reminder/${reminder._id}/`)
      .then(() => this.getMyReminders())
      .catch(() => {});
  }

  setReminderPause(
    isPaused: boolean,
    dateRange: {
      beginDate: { day: number; month: number; year: number };
      endDate: { day: number; month: number; year: number };
    },
  ) {
    return this.backendService.put(`user/me`, {
      reminderPause: {
        isPaused: isPaused,
        dateRange: dateRange,
      },
    });
  }

  getReminderPause(): Promise<{
    isPaused: boolean;
    dateRange: {
      beginDate: { day: number; month: number; year: number };
      endDate: { day: number; month: number; year: number };
    };
  }> {
    return this.backendService.get('user/me').then((result: User) => {
      return {
        isPaused: result.reminderPause.isPaused,
        dateRange: result.reminderPause.dateRange,
      };
    });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/services/reminder.service.ts